import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/tire-size-calculator',
  component: () => import('../../routes/TireSizeCalculator.svelte'),
  card: {
    id: 'tire-size-calculator',
    title: 'Tire Size Calculator',
    description:
      'Compare two tire sizes (P-metric 225/45R17 format) for sidewall height, overall diameter, circumference, revolutions per mile, speedometer error, and odometer error. Includes 6 fitment presets and a 4-bucket fitment verdict (perfect / mild / moderate / significant).',
    icon: 'trip_origin',
    iconBgClass: 'bg-cyan-50',
    iconTextClass: 'text-cyan-600',
    href: '/tire-size-calculator',
    category: 'Travel & Distance',
  },
  seo: {
    title:
      'Tire Size Calculator – Speedometer Error, Diameter, Revs/Mile & Plus-Sizing',
    description:
      'Free tire size calculator: compare any two P-metric tire sizes (e.g. 225/45R17 vs 245/40R18) for sidewall height, overall diameter, circumference, revolutions per mile and km, speedometer error percentage, odometer error, and actual ground speed at speedo-60. Includes 6 common plus-sizing and winter-downsize presets. P-metric (TRA) compliant.',
  },
};

export default meta;
